import _find from "lodash/find";

export const styles = [
    {
        key: "courteous",
        name: "Courtois",
    },
    {
        key: "creative",
        name: "Créatif",
    },
    {
        key: "curious",
        name: "Curieux",
    },
    {
        key: "dynamic",
        name: "Dynamique",
    },
    {
        key: "funny",
        name: "Drôle",
    },
    {
        key: "effective",
        name: "Efficace",
    },
    {
        key: "empathetic",
        name: "Empathique",
    },
    {
        key: "enthusiastic",
        name: "Enthousiaste",
    },
    {
        key: "jovial",
        name: "Jovial",
    },
    {
        key: "methodical",
        name: "Méthodique",
    },
    {
        key: "motivated",
        name: "Motivé",
    },
    {
        key: "organized",
        name: "Organisé",
    },
    {
        key: "versatile",
        name: "Polyvalent",
    },
    {
        key: "professional",
        name: "Professionnel",
    },
    {
        key: "sensitive",
        name: "Sensible",
    },
    {
        key: "sociable",
        name: "Sociable",
    },
];

export const getStyle = (style) => {
    return _find(styles, ["key", style]);
};

export const writingStyles = [
    {
        key: "narrative",
        name: "Narratif",
    },
    {
        key: "descriptive",
        name: "Descriptif",
    },
    {
        key: "objective",
        name: "Objectif",
    },
    {
        key: "poetic",
        name: "Poétique",
    },
    {
        key: "persuasive",
        name: "Persuasif",
    },
    {
        key: "expository",
        name: "Expositoire",
    },
    {
        key: "creative",
        name: "Créatif",
    },
    {
        key: "technical",
        name: "Technique",
    },
    {
        key: "entertaining",
        name: "Divertissant",
    },
    {
        key: "subjective",
        name: "Subjectif",
    },

    {
        key: "funny",
        name: "Drôle",
    },
    {
        key: "sales-oriented",
        name: "Vendeur",
    },
    {
        key: "formal",
        name: "Soutenu",
    },
    {
        key: "ironic",
        name: "Ironique",
    },
    {
        key: "inspiring",
        name: "Inspirant",
    },
    {
        key: "educative",
        name: "Éducatif",
    },
    {
        key: "motivating",
        name: "Motivant",
    },
    {
        key: "informal",
        name: "Informel",
    },
    {
        key: "provocative",
        name: "Provocateur",
    },
    {
        key: "emotional",
        name: "Émotionnel",
    },
    {
        key: "critical",
        name: "Critique",
    },
    {
        key: "sarcastic",
        name: "Sarcastique",
    },
    {
        key: "imaginative",
        name: "Imaginatif",
    },
    {
        key: "pragmatic",
        name: "Pragmatique",
    },
    {
        key: "argumentative",
        name: "Argumentatif",
    },
    {
        key: "factual",
        name: "Factuel",
    },
];

export const getWritingStyle = (style) => {
    return _find(writingStyles, ["key", style]);
};
